import { useRfsClusterSummary } from "@/api/rfs";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useParams } from "react-router-dom";

export default function ClusterSummary() {
  const { id } = useParams();
  const { data } = useRfsClusterSummary({ id: id! });

  const formatKey = (key: string): string => {
    return key
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/^./, (str) => str.toUpperCase())
      .trim();
  };

  return (
    <div className="mt-10">
      <Accordion type="single" collapsible className="w-full">
        <AccordionItem value={"clusterSummary"}>
          <AccordionTrigger>
            <span className="text-xl font-semibold leading-none tracking-tight">
              Cluster Summary
            </span>
          </AccordionTrigger>
          <AccordionContent>
            <table className="w-full table-auto border">
              <thead className="bg-slate-50">
                <tr>
                  <th className="border-x p-4 text-left text-sm font-medium">
                    Summary
                  </th>
                  <th className="border-x p-4 text-left text-sm font-medium">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-y">
                  <td className="border-x p-4 text-sm">HP</td>
                  <td className="border-x p-4 text-sm">{data?.hp ?? "-"}</td>
                </tr>
                <tr className="border-y">
                  <td className="border-x p-4 text-sm">FDT</td>
                  <td className="border-x p-4 text-sm">{data?.fdt ?? "-"}</td>
                </tr>
                <tr className="border-y">
                  <td className="border-x p-4 text-sm">FAT</td>
                  <td className="border-x p-4 text-sm">{data?.fat ?? "-"}</td>
                </tr>
                <tr className="border-y">
                  <td className="border-x p-4 text-sm">Clamp Hook</td>
                  <td className="border-x p-4 text-sm">
                    {data?.clampHook ?? "-"}
                  </td>
                </tr>
                <tr className="border-y">
                  <td className="border-x p-4 text-sm">Qspan</td>
                  <td className="border-x p-4 text-sm">{data?.qspan ?? "-"}</td>
                </tr>
                {data?.deploymentType &&
                  Object.entries(data.deploymentType).map(
                    ([nestedKey, nestedValue]) => (
                      <tr key={`${nestedKey}`} className="border-y">
                        <td className="border-x p-4 text-sm">
                          Deployment Type - {formatKey(nestedKey)}
                        </td>
                        <td className="border-x p-4 text-sm">
                          {nestedValue ?? "-"}
                        </td>
                      </tr>
                    ),
                  )}
                {(!data?.deploymentType ||
                  Object.keys(data.deploymentType).length === 0) && (
                  <tr>
                    <td className="border-x p-4 text-sm">Deployment Type</td>
                    <td className="border-x p-4 text-sm">-</td>
                  </tr>
                )}
              </tbody>
            </table>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
}
